$(document).ready(function ()
{
  $(document).on("swell:setup", function ()
  {
    if (spapi.authenticated)
    {
      if (window.location.href.indexOf("cart") < 0)
      {
        $(".swell-checkout .redeem-title .mini-cart").html(spapi.customer.adjusted_points_balance);
      }
      populateRedemptions();
      $(".swell-checkout").show();
    }
    $("#swell-redemption-options").prepend("<option value='choose'>Choose your rewards</option>");
    $("#swell-redemption-options").val("choose");
    dropdown_update();
    $(".field__input--select").on('change', function ()
    {
      dropdown_update();
    });
  });

  $('body').on('click', ".swell-model-close", function ()
  {
    $(".swell-modal").hide();
  });

  $('body').on('click', "#swell-redeem-btn", function (e)
  {
    e.preventDefault();
    redemptionId = $("#swell-redemption-options").val();
    $(".coupon-loader").show();
    $("#swell-redeem-btn .btn__content").hide();
    var onRedemptionSuccess = function (redemption)
    {
      $("#swell-reward-heading").html(redemption.redemptionOption.name);
      $("#swell-coupon-intro").html(redemption.redemptionOption.description);
      $("#swell-reward-intro").html(redemption.redemptionOption.reward_intro);
      $("#swell-coupon-code").html(redemption.couponCode);
      $(".swell-copuon-error").css("display", "none");
      $(".swell-modal").css("display", "flex");
      $(".coupon-loader").hide();
      $("#swell-redeem-btn .btn__content").show();
    }
    var onError = function (err)
    {
      $(".coupon-loader").hide();
      $("#swell-redeem-btn .btn__content").show();
      $(".swell-copuon-error").css("display", "none");
      $(".swell-copuon-error").html("");
      $(".swell-copuon-error").html("Sorry, you don't have enough points for this reward.");
      $(".swell-copuon-error").css("display", "block");
      $("#couponcode").val('');
    }
    swellAPI.makeRedemption(
    {
      redemptionOptionId: redemptionId
    }, onRedemptionSuccess, onError);
  });
});

function dropdown_update()
{
  if ($("#swell-redemption-options").val() == 'choose')
  {
    $("#swell-redeem-btn").attr("disabled", "disabled");
    $("#swell-redeem-btn").css("opacity", "0.8");
  }
  else
  {
    $("#swell-redeem-btn").removeAttr("disabled");
    $("#swell-redeem-btn").css("opacity", "1");
  }

}

function populateRedemptions()
{
  spapi.activeRedemptionOptions.forEach(function (redemption)
  {
    if (redemption.discount_type == "fixed_amount")
    {
      $("#swell-redemption-options").append("<option value=" + redemption.id + ">" + redemption.name + " = " + redemption.cost_text + "</option>")
    }
  });
}